import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '@lib/components/common/Button';
import Loader from '@lib/components/common/Loader';
import SPFSOCartIndexPage from './SPFSOCartIndexPage';
import store from '@lib/store/SparePartsFinderTextSearchBasketStore';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import SparePartsFinderSOBasketApiService from '@lib/api-services/SparePartsFinderSOBasketApiService';

export default class SPFSOCart extends React.Component {

    state = {
        loading: true,
        index: null
    }

    constructor(props) {
        super(props);
        this.init();
    }

    init() {
        var apiService = APIServicesRegistry.getService(SparePartsFinderSOBasketApiService);
        var data = this.createFilter();

        apiService.index(data).then(response => {
            this.setState({
                index: response.data
            })
        })
    }

    render() {
        if (!this.state.index) {
            return (
                <Modal isOpen={true} class="text-search-modal" onClose={() => store.setBasketIsOpen(false)}
                       width="auto">
                    <Modal.Body>
                        <Loader fillContainer={true}/>
                    </Modal.Body>
                </Modal>
            )
        }
        return (
            <Modal isOpen={true} class="text-search-modal" onClose={() => store.setBasketIsOpen(false)} width="auto">
                <Modal.Header>{__('Spare parts basket')}</Modal.Header>
                <Modal.Body>
                    <SPFSOCartIndexPage  {...this.getIndexPageProps()} />
                </Modal.Body>
                <Modal.Footer>
                    <Button theme={Button.Theme.BorderOnly}
                            onClick={() => store.setBasketIsOpen(false)}>{__('Close')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    createFilter = () => {
        return {
            market: this.props.market,
            searchParameterConfigurationIds: store.searchParameterConfigurationIds
        }
    }

    getIndexPageProps() {
        return {
            ...this.state.index,
            indexApiService: SparePartsFinderSOBasketApiService,
            createFilter: this.createFilter,
            onRemoveSelectedFromBasketClick: this.onRemoveSelectedFromBasketClick
        }
    }

    onRemoveSelectedFromBasketClick = (page) => {
        var apiService = APIServicesRegistry.getService(SparePartsFinderSOBasketApiService);
        var data = this.createFilter();

        apiService.index(data).then(response => {
            page.setState({
                results: response.data.results
            }, () => {
                this.setState({
                    index: response.data
                })
            })
        })
    }
}